module.exports = __webpack_public_path__ + "static/media/walleticon3.91d8362b.png";